<template>
  <div class="additional-left-menu">
    <div class="filter-snapshot-container p-3 pb-4">
      <div class="hvh-flex space-between align-baseline">
        <b class="no-wrap">Filter Snapshot</b>
        <span class="uppercase clear">Clear</span>
      </div>
      <v-select class="mt-2 pt-0" :items="filterSnapshots" />
      <v-btn class="new-filter m-0" outline color="#666ADF">CREATE NEW FILTER SNAPSHOT</v-btn>
    </div>
    <div class="filter-container p-3 pb-4">
      <b class="no-wrap">Data Retrieval Date</b>

      <CohortDateRangeFilter :value="value.dateRange" @input="emitData({ dateRange: $event })" />

      <div class="mt-4 pt-3">
        <b class="no-wrap">State Selection</b>
        <CohortStateSelectFilter class="mt-2 pt-0" :value="value.area.states" @input="emitData({ area: { states: $event } })" />
      </div>

      <div class="mt-3 pt-1">
        <b class="no-wrap">Gender</b>
        <CohortCheckBoxFilter class="mt-2 pt-0" :items="genders" :value="value.genders" @input="emitData({ genders: $event })" />
      </div>

      <div class="mt-3 pt-1">
        <b class="no-wrap">Insurance Distribution</b>
        <CohortCheckBoxFilter class="mt-2 pt-0" :items="insurances" :value="value.insurances" @input="emitData({ insurances: $event })" />
      </div>

      <div class="mt-3 pt-1">
        <b class="no-wrap">Age Range at Index</b>
        <CohortCheckBoxFilter class="mt-2 pt-0" :items="ages" :value="value.agesAtIndex" @input="emitData({ agesAtIndex: $event })" />
      </div>

      <div class="mt-3 pt-1">
        <b class="no-wrap">Current Age Range</b>
        <CohortCheckBoxFilter class="mt-2 pt-0" :items="ages" :value="value.ages" @input="emitData({ ages: $event })" />
      </div>
    </div>
  </div>
</template>

<script>
import { getDemographics } from '../../libraries/cohorts';
import CohortCheckBoxFilter from '../analytics/cohorts/cohortFilters/CohortCheckBoxFilter.vue';
import CohortStateSelectFilter from '../analytics/cohorts/cohortFilters/CohortStateSelectFilter.vue';
import CohortDateRangeFilter from '../analytics/cohorts/cohortFilters/CohortDateRangeFilter.vue';
export default {
  components: { CohortCheckBoxFilter, CohortStateSelectFilter, CohortDateRangeFilter },
  props: ['value'],
  data() {
    var demographics = getDemographics();

    return {
      filterSnapshots: ['test'],
      genders: demographics.genders,
      insurances: demographics.insurances,
      ages: demographics.ages,
    };
  },
  methods: {
    emitData(event) {
      this.$emit('input', {
        ...this.value,
        ...event
      });
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortLeftMenu'] = this;
  },
}
</script>

<style lang="scss" scoped>
.additional-left-menu {
  min-height: 100%;
  width: 252px;
  background-color: #e6f6f8;
  .filter-snapshot-container {
    background-color: #ffffff;
    .clear {
      color: #666adf;
      font-size: 12px;
    }

    button {
      padding: 8px 10px;
      border-radius: 7px;
      background-color: #666adf;
      color: white;
      font-size: 14px;
      width: 100%;
    }

    .new-filter {
      background-color: #ffffff !important;
      font-size: 11px;
      font-weight: bold;
    }
  }
}
</style>